@if (product(); as product) {
  <div class="card rounded-1 overflow-auto h-100">
    <div class="card-header d-flex bg-white sticky-top py-3 px-4">
      <button
        [ngbTooltip]="
          'configurationPage.products.form.tooltips.back' | translate
        "
        triggers="hover"
        class="icon-btn-clear icon-btn-lg me-2"
        data-cy="back-btn"
        (click)="checkForChanges($event)"
      >
        <i class="fa-light fa-chevron-left"></i>
      </button>
      @if (!layoutService.mobileView() || mode === ModalMode.Create) {
        <h3 class="m-0">
          {{
            mode === ModalMode.Create
              ? ('configurationPage.products.form.titles.create' | translate)
              : product.internalName
          }}
        </h3>
      }
      <div class="flex-fill"></div>
      <div class="d-block">
        <button
          [ngbTooltip]="
            'configurationPage.products.form.tooltips.save' | translate
          "
          triggers="hover"
          class="btn btn-primary me-2"
          data-cy="save-btn"
          (click)="save()"
        >
          <i class="fa-light fa-floppy-disk fa-lg pe-md-2"></i>
          @if (!layoutService.mobileView()) {
            {{
              mode === ModalMode.Create
                ? ('configurationPage.products.form.actions.create' | translate)
                : ('configurationPage.products.form.actions.update' | translate)
            }}
          }
        </button>
      </div>
    </div>
    <div class="card-body px-4">
      <form [formGroup]="form">
        <div class="row mb-3" data-cy="name-row">
          <label class="col-12 col-md-3 text-md-end label mt-2">
            {{ 'configurationPage.products.form.fields.name' | translate }}
          </label>
          <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <input
              type="text"
              class="form-control mb-2 w-100"
              formControlName="name"
              data-cy="name-input"
            />
            @if (c('name').touched) {
              @if (c('name').errors?.required) {
                <div class="text-danger small">
                  {{
                    'configurationPage.products.form.errors.required'
                      | translate
                  }}
                </div>
              }
            }
          </div>
        </div>
        <div class="row mb-3" data-cy="internal-name-row">
          <label class="col-12 col-md-3 text-md-end label mt-2">
            {{
              'configurationPage.products.form.fields.internalName' | translate
            }}
          </label>
          <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <input
              type="text"
              class="form-control mb-2 w-100"
              formControlName="internalName"
              data-cy="internal-name-input"
            />
            @if (c('internalName').touched) {
              @if (c('internalName').errors?.required) {
                <div class="text-danger small">
                  {{
                    'configurationPage.products.form.errors.required'
                      | translate
                  }}
                </div>
              }
            }
          </div>
        </div>
        <div class="row mb-3" data-cy="brand-row">
          <label class="col-12 col-md-3 text-md-end label mt-2">
            {{ 'configurationPage.products.form.fields.brand' | translate }}
          </label>
          <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <app-select
              class="mb-2"
              formControlName="brand"
              [placeholder]="
                'configurationPage.products.form.placeholders.selectBrand'
                  | translate
              "
              data-cy="brand-select"
            >
              @for (enum of ServiceType | keyvalue; track enum.value) {
                <app-select-option [value]="enum.value" [label]="enum.value" />
              }
            </app-select>
            @if (c('brand').touched) {
              @if (c('brand').errors?.required) {
                <div class="text-danger small">
                  {{
                    'configurationPage.products.form.errors.required'
                      | translate
                  }}
                </div>
              }
            }
          </div>
        </div>
        <div class="row mb-3" data-cy="analysis-type-row">
          <label class="col-12 col-md-3 text-md-end label mt-2">
            {{
              'configurationPage.products.form.fields.analysisType' | translate
            }}
          </label>
          <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <app-select
              formControlName="analysisType"
              class="mb-2"
              [placeholder]="
                'configurationPage.products.form.placeholders.selectType'
                  | translate
              "
              data-cy="analysis-type-select"
            >
              @for (enum of AnalysisType | keyvalue; track enum.value) {
                <app-select-option [value]="enum.value" [label]="enum.value" />
              }
            </app-select>
            @if (c('analysisType').touched) {
              @if (c('analysisType').errors?.required) {
                <div class="text-danger small">
                  {{
                    'configurationPage.products.form.errors.required'
                      | translate
                  }}
                </div>
              }
            }
          </div>
        </div>
        <div class="row mb-3" data-cy="data-input-type-row">
          <label class="col-12 col-md-3 text-md-end label mt-2">
            {{
              'configurationPage.products.form.fields.dataInputType' | translate
            }}
          </label>
          <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <app-select
              formControlName="dataInputType"
              class="mb-2"
              [placeholder]="
                'configurationPage.products.form.placeholders.selectType'
                  | translate
              "
              data-cy="data-input-type-select"
            >
              @for (enum of DataInputType | keyvalue; track enum.value) {
                <app-select-option [value]="enum.value" [label]="enum.value" />
              }
            </app-select>
            @if (c('dataInputType').touched) {
              @if (c('dataInputType').errors?.required) {
                <div class="text-danger small">
                  {{
                    'configurationPage.products.form.errors.required'
                      | translate
                  }}
                </div>
              }
            }
          </div>
        </div>
        <div class="row mb-3" data-cy="analysis-product-code-row">
          <label class="col-12 col-md-3 text-md-end label mt-2">
            {{
              'configurationPage.products.form.fields.analysisProductCode'
                | translate
            }}
          </label>
          <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <div class="d-flex flex-column gap-2">
              <div class="d-flex flex-wrap gap-2 align-items-center">
                <app-select
                  class="flex-fill"
                  [formControl]="analysisProductCodeLab"
                  [placeholder]="
                    'configurationPage.products.form.placeholders.selectLaboratory'
                      | translate
                  "
                  data-cy="analysis-product-code-lab-select"
                >
                  @for (lab of availableLaboratories(); track lab) {
                    <app-select-option [value]="lab" [label]="lab" />
                  }
                </app-select>
                <app-select
                  class="flex-fill"
                  [formControl]="analysisProductCodeValue"
                  [placeholder]="
                    'configurationPage.products.form.placeholders.selectCode'
                      | translate
                  "
                  data-cy="analysis-product-code-select"
                >
                  @for (code of analysisProductCodeOptions(); track code.code) {
                    <app-select-option
                      [value]="code.code"
                      [label]="
                        'laboratoryAnalysisCode.' + code.code | translate
                      "
                    />
                  }
                </app-select>
                <button
                  class="btn btn-outline-primary"
                  type="button"
                  (click)="addAnalysisProductCode()"
                  [disabled]="
                    !analysisProductCodeLab.value ||
                    !analysisProductCodeValue.value
                  "
                  data-cy="analysis-product-code-add"
                >
                  {{
                    'configurationPage.products.form.actions.add' | translate
                  }}
                </button>
              </div>
              @for (
                entry of getAnalysisProductCodeEntries();
                track entry.laboratory
              ) {
                <div class="d-flex align-items-center gap-2">
                  <div class="text-muted small" style="min-width: 140px">
                    {{ entry.laboratory }}
                  </div>
                  <div class="flex-fill">
                    {{ 'laboratoryAnalysisCode.' + entry.code | translate }}
                  </div>
                  <button
                    type="button"
                    class="icon-btn-clear icon-btn-lg"
                    [ngbTooltip]="
                      'configurationPage.products.form.tooltips.removeCode'
                        | translate
                    "
                    triggers="hover"
                    (click)="removeAnalysisProductCode(entry.laboratory)"
                    [attr.data-cy]="
                      'analysis-product-code-remove-' + entry.laboratory
                    "
                  >
                    <i class="fa-light fa-xmark"></i>
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row mb-3" data-cy="analysis-type-row">
          <label class="col-3 text-end label mt-2">
            {{ 'configurationPage.products.form.fields.scheme' | translate }}
          </label>
          <div class="col-8 col-lg-6 col-xl-4">
            <app-select
              formControlName="schemeId"
              class="mb-2"
              [placeholder]="
                'configurationPage.products.form.placeholders.selectScheme'
                  | translate
              "
              data-cy="scheme-select"
            >
              @for (scheme of schemes(); track scheme.id) {
                <app-select-option
                  [disabled]="!!scheme.deactivated"
                  [value]="scheme.id"
                  [label]="scheme.name"
                />
              }
            </app-select>
            @if (c('schemeId').touched) {
              @if (c('schemeId').errors?.required) {
                <div class="text-danger small">
                  {{
                    'configurationPage.products.form.errors.required'
                      | translate
                  }}
                </div>
              }
            }
          </div>
        </div>
        <div class="row mb-3" data-cy="analysis-type-row">
          <label class="col-3 text-end label mt-2">
            {{ 'configurationPage.products.form.fields.template' | translate }}
          </label>
          <div class="col-8 col-lg-6 col-xl-4">
            <app-select
              formControlName="templateId"
              class="mb-2"
              [placeholder]="
                'configurationPage.products.form.placeholders.selectTemplate'
                  | translate
              "
              data-cy="template-select"
            >
              @for (template of templates(); track template.id) {
                <app-select-option
                  [value]="template.id"
                  [label]="template.name"
                />
              }
            </app-select>
            @if (c('templateId').touched) {
              @if (c('templateId').errors?.required) {
                <div class="text-danger small">
                  {{
                    'configurationPage.products.form.errors.required'
                      | translate
                  }}
                </div>
              }
            }
          </div>
        </div>
        @if (
          additionalFields().includes(ProductAdditionalFields.ProductSubTypes)
        ) {
          <div class="row mb-3" data-cy="sub-type-row">
            <label class="col-12 col-md-3 text-md-end label mt-2">
              {{ 'configurationPage.products.form.fields.type' | translate }}
            </label>
            <div class="col-12 col-md-8 col-lg-6 col-xl-4">
              <app-multi-select
                formControlName="productSubTypes"
                class="mb-2"
                [placeholder]="
                  'configurationPage.products.form.placeholders.selectProductTypes'
                    | translate
                "
                data-cy="sub-type-select"
              >
                <app-multi-select-checkbox
                  [label]="
                    'configurationPage.products.form.options.singleton'
                      | translate
                  "
                  [value]="PregnancyType.singleton"
                />
                <app-multi-select-checkbox
                  [label]="
                    'configurationPage.products.form.options.twins' | translate
                  "
                  [value]="PregnancyType.twins"
                />
              </app-multi-select>
              @if (c('productSubTypes').touched) {
                @if (c('productSubTypes').errors?.required) {
                  <div class="text-danger small">
                    {{
                      'configurationPage.products.form.errors.required'
                        | translate
                    }}
                  </div>
                }
              }
            </div>
          </div>
        }
        @if (
          additionalFields().includes(
            ProductAdditionalFields.IncidentalFindings
          )
        ) {
          <div class="row mb-3" data-cy="incidental-findings-row">
            <label class="col-12 col-md-3 text-md-end label mt-2">
              {{
                'configurationPage.products.form.fields.incidentalFindings'
                  | translate
              }}
            </label>
            <div class="col-12 col-md-8 col-lg-6 col-xl-4">
              <app-select
                formControlName="incidentalFindingsReporting"
                class="mb-2"
                [placeholder]="
                  'configurationPage.products.form.placeholders.incidentalFindings'
                    | translate
                "
                data-cy="incidental-findings-select"
              >
                <app-select-option
                  [label]="
                    'configurationPage.products.form.options.always' | translate
                  "
                  [value]="IncidentalFindingsReporting.Always"
                />
                <app-select-option
                  [label]="
                    'configurationPage.products.form.options.ask' | translate
                  "
                  [value]="IncidentalFindingsReporting.Ask"
                />
                <app-select-option
                  [label]="
                    'configurationPage.products.form.options.never' | translate
                  "
                  [value]="IncidentalFindingsReporting.Never"
                />
              </app-select>
              @if (c('incidentalFindingsReporting').touched) {
                @if (c('incidentalFindingsReporting').errors?.required) {
                  <div class="text-danger small">
                    {{
                      'configurationPage.products.form.errors.required'
                        | translate
                    }}
                  </div>
                }
              }
            </div>
          </div>
        }
        @if (additionalFields().includes(ProductAdditionalFields.Sex)) {
          <div class="row mb-3" data-cy="sex-row">
            <label class="col-12 col-md-3 text-md-end label mt-2">
              {{ 'configurationPage.products.form.fields.sex' | translate }}
            </label>
            <div class="col-12 col-md-8 col-lg-6 col-xl-4">
              <app-multi-select
                formControlName="sex"
                class="mb-2"
                [placeholder]="
                  'configurationPage.products.form.placeholders.sex' | translate
                "
                data-cy="sex-select"
              >
                <app-multi-select-checkbox
                  [label]="
                    'configurationPage.products.form.options.male' | translate
                  "
                  [value]="Gender.Male"
                />
                <app-multi-select-checkbox
                  [label]="
                    'configurationPage.products.form.options.female' | translate
                  "
                  [value]="Gender.Female"
                />
              </app-multi-select>
              @if (c('sex').touched) {
                @if (c('sex').errors?.required) {
                  <div class="text-danger small">
                    {{
                      'configurationPage.products.form.errors.required'
                        | translate
                    }}
                  </div>
                }
              }
            </div>
          </div>
        }
        @if (additionalFields().includes(ProductAdditionalFields.SampleTypes)) {
          <div class="row mb-3" data-cy="sample-types-row">
            <label class="col-12 col-md-3 text-md-end label mt-2">
              {{
                'configurationPage.products.form.fields.sampleTypes' | translate
              }}
            </label>
            <div class="col-12 col-md-8 col-lg-6 col-xl-4">
              <app-multi-select
                formControlName="allowedSampleTypes"
                class="mb-2"
                [placeholder]="
                  'configurationPage.products.form.placeholders.sampleTypes'
                    | translate
                "
                data-cy="sample-types-select"
              >
                @for (type of sampleTypeOptions; track type) {
                  <app-multi-select-checkbox
                    [label]="
                      'sample.form.sampleTypes.' + sampleTypeKey(type)
                        | translate
                    "
                    [value]="type"
                  />
                }
              </app-multi-select>
              @if (c('allowedSampleTypes').touched) {
                @if (c('allowedSampleTypes').errors?.required) {
                  <div class="text-danger small">
                    {{
                      'configurationPage.products.form.errors.required'
                        | translate
                    }}
                  </div>
                }
              }
            </div>
          </div>
        }
        @if (
          additionalFields().includes(
            ProductAdditionalFields.RequirePatientAddress
          )
        ) {
          <div class="row mb-3" data-cy="patient-address-required-row">
            <label
              class="col-12 col-md-3 text-md-end label"
              for="requirePatientAddress"
            >
              {{
                'configurationPage.products.form.fields.requirePatientAddress'
                  | translate
              }}
            </label>
            <div class="col-12 col-md-8 col-lg-6 col-xl-4">
              <div class="form-check form-check-lg">
                <input
                  class="form-check-input form-check-primary"
                  type="checkbox"
                  id="requirePatientAddress"
                  formControlName="requirePatientAddress"
                  data-cy="patient-address-required-checkbox"
                />
              </div>
            </div>
          </div>
        }
        <hr />
        <div class="row mb-3" data-cy="child-products-row">
          <label class="col-12 col-md-3 text-md-end label mt-2">
            {{
              'configurationPage.products.form.fields.childProducts' | translate
            }}
          </label>
          @if (products(); as products) {
            <div class="col-12 col-md-8 col-lg-6 col-xl-4">
              <app-configuration-typeahead
                [placeholder]="
                  'configurationPage.products.form.placeholders.selectProduct'
                    | translate
                "
                [items]="filteredProducts()"
                [dataCy]="'child-products-input'"
                [displayPropertyName]="'internalName'"
                (selected)="onProductSelection($event)"
              />
              @for (productId of c('childProductIds').value; track productId) {
                <div class="d-flex align-items-center">
                  {{
                    productId | displayName: products : 'id' : 'internalName'
                  }}
                  ({{
                    productId | displayName: products : 'id' : 'analysisType'
                  }})
                  <button
                    ghost
                    class="icon-btn-clear icon-btn-lg"
                    [ngbTooltip]="
                      'configurationPage.products.form.tooltips.removeProduct'
                        | translate
                    "
                    triggers="hover"
                    (click)="removeProduct(productId)"
                    data-cy="remove-product-btn"
                  >
                    <i class="fa-light fa-xmark"></i>
                  </button>
                </div>
              }
            </div>
          }
        </div>
        <hr />
        <div class="row mb-3" data-cy="wholesale-price-id-row">
          <label class="col-12 col-md-3 text-md-end label mt-2">
            {{
              'configurationPage.products.form.fields.wholesalePriceExternalId'
                | translate
            }}
          </label>
          <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <div class="icon-input-wrapper">
              <input
                formControlName="externalId"
                type="text"
                id="identsInput"
                class="form-control pe-5"
                [placeholder]="
                  'configurationPage.products.form.placeholders.selectExternalId'
                    | translate
                "
                data-cy="wholesale-price-id-input"
                [inputFormatter]="identFormatter"
                [resultFormatter]="identResultFormatter"
                [ngbTypeahead]="filterIdents"
                (focus)="onFocusTypeahead($event)"
              />
              <i class="fa-light fa-chevron-down"></i>
            </div>
          </div>
        </div>
        <div class="row mb-3" data-cy="end-user-price-id-row">
          <label class="col-12 col-md-3 text-md-end label mt-2">
            {{
              'configurationPage.products.form.fields.endUserPriceExternalId'
                | translate
            }}
          </label>
          <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <div class="icon-input-wrapper">
              <input
                formControlName="externalId2"
                type="text"
                id="identsInput2"
                class="form-control pe-5"
                [placeholder]="
                  'configurationPage.products.form.placeholders.selectExternalId'
                    | translate
                "
                data-cy="end-user-price-id-input"
                [inputFormatter]="identFormatter"
                [resultFormatter]="identResultFormatter"
                [ngbTypeahead]="filterIdents"
                (focus)="onFocusTypeahead($event)"
              />
              <i class="fa-light fa-chevron-down"></i>
            </div>
          </div>
        </div>
        <div class="row mb-3" data-cy="doctor-fee-id-row">
          <label class="col-12 col-md-3 text-md-end label mt-2">
            {{
              'configurationPage.products.form.fields.doctorFeeExternalId'
                | translate
            }}
          </label>
          <div class="col-12 col-md-8 col-lg-6 col-xl-4">
            <div class="icon-input-wrapper">
              <input
                formControlName="externalId3"
                type="text"
                id="identsInput3"
                class="form-control pe-5"
                [placeholder]="
                  'configurationPage.products.form.placeholders.selectExternalId'
                    | translate
                "
                data-cy="doctor-fee-id-input"
                [inputFormatter]="identFormatter"
                [resultFormatter]="identResultFormatter"
                [ngbTypeahead]="filterIdents"
                (focus)="onFocusTypeahead($event)"
              />
              <i class="fa-light fa-chevron-down"></i>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
}
